import { Suspense } from "react";
import UniversalLoading from "@/components/loading/UniversalLoading";
import LoginForm from "@/components/auth/LoginForm";

export const LoginView = () => {
  return (
    <Suspense
      fallback={
        <div className="overflow-y-hidden">
          <UniversalLoading 
            variant="auth" 
            message="Loading login page..." 
          />
        </div>
      }
    >
      <LoginForm />
    </Suspense>
  );
};

export default LoginView;
